// This file is automatically generated. Do not edit manually.

import { IsoDateString } from "src/types/dateTime";
import { ProductChangeState } from "src/api/generated/erp/db/types/enums/productChangeState";
import { ProductChange } from "src/api/generated/erp/db/types/tables/productChange";
import { ProductChangeCategory } from "src/api/generated/erp/db/types/tables/productChangeCategory";
import { ProductChangePackage } from "src/api/generated/erp/db/types/tables/productChangePackage";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProductChangeEditApi {
	export async function getFormInitData(args: {
		productChangeId: number | null | undefined;
	}): Promise<ProductChangeEditApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/changes/edit/getFormInitData",
			method: "POST",
			data: {
				productChangeId: args.productChangeId,
			},
		});
		return response as ProductChangeEditApi_FormInitData;
	}

	export async function insert(args: {
		title: string;
		description: string;
		categoryId: number;
		packageId: number;
		responsiblePersonId: number | null | undefined;
		plannedCompletionDate: IsoDateString | null | undefined;
		state?: ProductChangeState;
		connectToRequestIds?: Array<number>;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/changes/edit/insert",
			method: "POST",
			data: {
				title: args.title,
				description: args.description,
				categoryId: args.categoryId,
				packageId: args.packageId,
				responsiblePersonId: args.responsiblePersonId,
				plannedCompletionDate: args.plannedCompletionDate,
				state: args.state,
				connectToRequestIds: args.connectToRequestIds,
			},
		});
		return response as number;
	}

	export async function update(args: { productChange: ProductChange }): Promise<ProductChange> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/changes/edit/update",
			method: "POST",
			data: {
				productChange: args.productChange,
			},
		});
		return response as ProductChange;
	}

	export async function setState(args: {
		productChangeIds: Array<number>;
		state: ProductChangeState;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/changes/edit/setState",
			method: "POST",
			data: {
				productChangeIds: args.productChangeIds,
				state: args.state,
			},
		});
		return response as void;
	}
}

export interface ProductChangeEditApi_FormInitData {
	categoryOptions: Array<ProductChangeCategory>;
	packageOptions: Array<ProductChangePackage>;
	productChange: ProductChange | null | undefined;
}
